
  export const CONCEPTOMEDICIONS_RECEIVED = "CONCEPTOMEDICIONS_RECEIVED";
  export const SET_CONCEPTOMEDICION = "SET_CONCEPTOMEDICION";
  export const CREATE_CONCEPTOMEDICION = "CREATE_CONCEPTOMEDICION";
  export const SET_PROPERTY_CONCEPTOMEDICION = "SET_PROPERTY_CONCEPTOMEDICION";
  